var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LazyYoutube',{staticClass:"external-video",attrs:{"max-width":"1200px","src":_vm.computedSrc,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }